import { Component } from 'react';
import PropTypes from "prop-types";
import { Route, Routes } from "react-router-dom";

// Helpers.
import Helmet from "react-helmet";

// Constants.
import { DATA_INITIALISING, DATA_LOADED, DATA_LOADING } from "../../../../component/Constants";

// APis
import IntegrationsApi from "../../../../api/Integrations";

//Types
import IntegrationType from '../../../../types/integration/IntegrationType';

// Components.
import Breadcrumb from "../../../../container/breadcrumb";
import IntegrationTrail, { resolveProfileLabel } from "../../../../container/breadcrumb/IntegrationTrail";
import HeaderActions from "../../../../container/header_actions";
import ConditionalRender from "../../../../helpers/ConditionalRender";
import Detail from './Detail';
import List from "../email/List";


interface IEmailIntegrationsProps {
    toggleMenu: Function,
    isAdmin: boolean
}

interface IEmailIntegrationsState {
    loading: number,
    emailIntegration: IntegrationType[],
}

const initialState = {
    loading: DATA_INITIALISING,
    emailIntegration: []
}

class EmailIntegrations extends Component<IEmailIntegrationsProps, IEmailIntegrationsState> {
    static propTypes: {
        toggleMenu: PropTypes.Validator<(...args: any[]) => any>,
        isAdmin: PropTypes.Validator<boolean>;
    };

    constructor(props: IEmailIntegrationsProps) {
        super(props);

        this.state = initialState;
    };

    async getData() {
        // Get all events for all time.
        const emailIntegration = await IntegrationsApi.getNotificationIntegrationData('mail.smtp');

        this.setState({
            loading: DATA_LOADED,
            emailIntegration
        });
    }

    componentDidMount() {
        const { loading } = this.state;

        if (loading === DATA_INITIALISING) {

            this.setState({
                loading: DATA_LOADING
            });

            this.getData();
        }
    }

    /* Action Methods */
    refresh = () => {

        this.setState({
            loading: DATA_LOADING
        });

        this.getData();
    }

    render() {
        const { loading, emailIntegration } = this.state;

        return (
            <div id="content">
                <Helmet>
                    <title>Email Integration - Settings - DBmarlin</title>
                    <meta name="description" content="Manage email integration"/>
                </Helmet>

                <div id="top-header-wrapper" className="row row-cols-2">
                    <Breadcrumb heading="Email">
                        {[<IntegrationTrail key="email-trail" section="Email"
                                            sectionPath="/admin/integrations/email"
                                            resolveEntityLabel={resolveProfileLabel('email', emailIntegration)}/>]}
                    </Breadcrumb>
                    <HeaderActions toggleMenu={this.props.toggleMenu} refresh={this.refresh}
                                  />
                </div>

                <div className="loader">
                    <ConditionalRender if={false}>
                        <div className="bar"/>
                    </ConditionalRender>
                </div>

                <div className="row row-cols-1">
                    <Routes>
                        <Route path="/:actionId/:profileId" element={<Detail refresh={this.refresh} emailIntegration={emailIntegration} isAdmin={this.props.isAdmin}/>}/>
                        <Route path="/:actionId" element={<Detail refresh={this.refresh} emailIntegration={emailIntegration} isAdmin={this.props.isAdmin}/>}/>
                        <Route path="/" element={<List loading={loading} emailIntegration={emailIntegration} refresh={this.refresh} isAdmin={this.props.isAdmin}/>}/>
                    </Routes>
                </div>
            </div>
        )
    }
}

EmailIntegrations.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired
};

export default EmailIntegrations;
